// full page navigation (exit react app)
export const navToUrl = (url) => (window.location.href = url);
